import React, { lazy } from 'react';
import RoleGuard from '../../components/auth/RoleGuard';
import AuthGuard from '../../components/auth/AuthGuard';
import ErrorBoundary from '../../components/common/ErrorBoundary';
// Page components are code-split (lazy); <Suspense> lives in AuthenticatedRoutes.jsx.
const InstructorQuizList = lazy(() => import('../../pages/instructor/quizzes/InstructorQuizList'));
const InstructorQuizBuilder = lazy(() => import('../../pages/instructor/quizzes/InstructorQuizBuilder'));
const QuizPreview = lazy(() => import('../../pages/instructor/quizzes/QuizPreview'));
const QuizSubmissions = lazy(() => import('../../pages/instructor/quizzes/QuizSubmissions'));
const InstructorSubmissionView = lazy(() => import('../../pages/instructor/assignments/InstructorSubmissionView'));
const AssignmentPanel = lazy(() => import('../../pages/instructor/assignments/AssignmentPanel'));
const Gradebook = lazy(() => import('../../pages/instructor/grading/Gradebook'));
const LivePollBoard = lazy(() => import('../../pages/instructor/polls/LivePollBoard'));
const InstructorPollManager = lazy(() => import('../../pages/instructor/polls/InstructorPollManager'));

// The /instructor/* routes. Extracted VERBATIM (same order) from
// AuthenticatedRoutes' route table.
const instructorRoutes = [
  { path: '/instructor/polls', element: (
    <AuthGuard>
      <InstructorPollManager />
    </AuthGuard>
  ) },
  { path: '/instructor/live-poll', element: (
    <AuthGuard>
      <LivePollBoard />
    </AuthGuard>
  ) },
  { path: '/instructor/quizzes', element: (
    <RoleGuard allowedRoles={['instructor', 'admin']}>
      <InstructorQuizList />
    </RoleGuard>
  ) },
  { path: '/instructor/quizzes/new', element: (
    <RoleGuard allowedRoles={['instructor', 'admin']}>
      <ErrorBoundary>
        <InstructorQuizBuilder />
      </ErrorBoundary>
    </RoleGuard>
  ) },
  { path: '/instructor/quizzes/:quizId/edit', element: (
    <RoleGuard allowedRoles={['instructor', 'admin']}>
      <ErrorBoundary>
        <InstructorQuizBuilder />
      </ErrorBoundary>
    </RoleGuard>
  ) },
  { path: '/instructor/quizzes/:quizId/preview', element: (
    <RoleGuard allowedRoles={['instructor', 'admin']}>
      <QuizPreview />
    </RoleGuard>
  ) },
  { path: '/instructor/quizzes/:quizId/attempts', element: (
    <RoleGuard allowedRoles={['instructor', 'admin']}>
      <ErrorBoundary>
        <QuizSubmissions />
      </ErrorBoundary>
    </RoleGuard>
  ) },
  { path: '/instructor/submissions/:attemptId', element: (
    <RoleGuard allowedRoles={['instructor', 'admin']}>
      <InstructorSubmissionView />
    </RoleGuard>
  ) },
  { path: '/instructor/quizzes/:quizId/assign', element: (
    <RoleGuard allowedRoles={['instructor', 'admin']}>
      <AssignmentPanel />
    </RoleGuard>
  ) },
  { path: '/instructor/quizzes/:quizId', element: (
    <RoleGuard allowedRoles={['instructor', 'admin']}>
      <QuizPreview />
    </RoleGuard>
  ) },
  { path: '/instructor/gradebook', element: (
    <RoleGuard allowedRoles={['instructor', 'admin']}>
      <Gradebook />
    </RoleGuard>
  ) },
];

export default instructorRoutes;
